import { render, staticRenderFns } from "./kipcount_pos.vue?vue&type=template&id=2d477b5c"
import script from "./kipcount_pos.vue?vue&type=script&lang=js"
export * from "./kipcount_pos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports